(function(){
  if (window.__monetaNavInit) return;
  window.__monetaNavInit = true;

  var root = document.documentElement;

  function measure(){
    var ann = document.querySelector('.utility-bar');
    var hdr = document.querySelector('.header-wrapper');
    var h = 0;
    if (ann) h += ann.offsetHeight;
    if (hdr) h += hdr.offsetHeight;
    if (h > 0) root.style.setProperty('--mo-nav-h', h + 'px');
  }

  var ticking = false;
  function onScroll(){
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function(){
      if (window.scrollY > 24) root.classList.remove('mo-top');
      else root.classList.add('mo-top');
      ticking = false;
    });
  }

  function boot(){
    measure();
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure);
    if (window.ResizeObserver){
      var hdr = document.querySelector('.header-wrapper');
      if (hdr) new ResizeObserver(measure).observe(hdr);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
